var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "CopyBillingListItems",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  attrs: {
                    id: _vm.formId,
                    name: _vm.formName,
                    autofocus: "first"
                  },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "formMode",
                        label: _vm._f("pgettext")(
                          "Mode",
                          "CopyBillingListItems"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "8",
                        labelAlign: _vm.labelAlign
                      }
                    },
                    _vm._l(_vm.formModes, function(mode) {
                      return _c(
                        "BFormRadio",
                        {
                          key: mode.vaue,
                          attrs: { name: "formMode", value: mode.value },
                          model: {
                            value: _vm.selectedMode,
                            callback: function($$v) {
                              _vm.selectedMode = $$v
                            },
                            expression: "selectedMode"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(mode.name) + "\n        "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.isFieldVisible("product")
                    ? _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "product",
                            label: _vm._f("pgettext")(
                              "Service",
                              "CopyBillingListItems"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "8",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group  d-flex flex-row",
                            helpTooltip: _vm.fieldsByName["product"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "product_enabled" },
                                  model: {
                                    value: _vm.item.$updates.product,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "product",
                                        $$v
                                      )
                                    },
                                    expression: "item.$updates.product"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormSelect2", {
                            staticClass: "flex-grow-1",
                            attrs: {
                              name: "product",
                              "bind-object": "",
                              dataSource: _vm.b_814138253067422_dataSource,
                              textField: "name",
                              disabled: !_vm.item.$updates.product
                            },
                            on: {
                              optionSelected: function($event) {
                                return _vm.evh_814138253067422_optionSelected(
                                  $event,
                                  {}
                                )
                              }
                            },
                            model: {
                              value: _vm.item.product,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "product", $$v)
                              },
                              expression: "item.product"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("description")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "description",
                            label: _vm._f("pgettext")("Description", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip: _vm.fieldsByName["description"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "description_enabled" },
                                  model: {
                                    value: _vm.item.$updates.description,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "item.$updates.description"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              name: "description",
                              disabled: !_vm.item.$updates.description
                            },
                            model: {
                              value: _vm.item.description,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "description", $$v)
                              },
                              expression: "item.description"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("intermediated_service")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "intermediated_service",
                            label: _vm._f("pgettext")(
                              "Intermediated service",
                              "Invoice"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip:
                              _vm.fieldsByName["intermediated_service"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: {
                                    name: "intermediated_service_enabled"
                                  },
                                  model: {
                                    value:
                                      _vm.item.$updates.intermediated_service,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "intermediated_service",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.$updates.intermediated_service"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group-text" },
                            [
                              _c("ItpFormCheckbox", {
                                attrs: {
                                  name: "intermediated_service",
                                  disabled: !_vm.item.$updates
                                    .intermediated_service
                                },
                                model: {
                                  value: _vm.item.intermediated_service,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "intermediated_service",
                                      $$v
                                    )
                                  },
                                  expression: "item.intermediated_service"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("quantity")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "quantity",
                            label: _vm._f("pgettext")("Quantity", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "4",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip: _vm.fieldsByName["quantity"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "quantity_enabled" },
                                  model: {
                                    value: _vm.item.$updates.quantity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "quantity",
                                        $$v
                                      )
                                    },
                                    expression: "item.$updates.quantity"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              mask: "number",
                              unmask: "typed",
                              scale: "4",
                              name: "quantity",
                              disabled: !_vm.item.$updates.quantity
                            },
                            model: {
                              value: _vm.item.quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "quantity", $$v)
                              },
                              expression: "item.quantity"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("quantity_percentage")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "quantity_percentage",
                            label: _vm._f("pgettext")("Quantity %", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "3",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip:
                              _vm.fieldsByName["quantity_percentage"].help,
                            appendText: "%"
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: {
                                    name: "quantity_percentage_enabled"
                                  },
                                  model: {
                                    value:
                                      _vm.item.$updates.quantity_percentage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "quantity_percentage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.$updates.quantity_percentage"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              mask: "number",
                              unmask: "typed",
                              scale: "4",
                              name: "quantity_percentage",
                              disabled: !_vm.item.$updates.quantity_percentage
                            },
                            model: {
                              value: _vm.item.quantity_percentage,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "quantity_percentage", $$v)
                              },
                              expression: "item.quantity_percentage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("unit")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "unit",
                            label: _vm._f("pgettext")("Unit", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "4",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip: _vm.fieldsByName["unit"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "unit_enabled" },
                                  model: {
                                    value: _vm.item.$updates.unit,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item.$updates, "unit", $$v)
                                    },
                                    expression: "item.$updates.unit"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              name: "unit",
                              disabled: !_vm.item.$updates.unit
                            },
                            model: {
                              value: _vm.item.unit,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "unit", $$v)
                              },
                              expression: "item.unit"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("price")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "price",
                            label: _vm._f("pgettext")("Price", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "4",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip: _vm.fieldsByName["price"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "price_enabled" },
                                  model: {
                                    value: _vm.item.$updates.price,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item.$updates, "price", $$v)
                                    },
                                    expression: "item.$updates.price"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              mask: "number",
                              unmask: "typed",
                              scale: "2",
                              name: "price",
                              disabled: !_vm.item.$updates.price
                            },
                            model: {
                              value: _vm.item.price,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "price", $$v)
                              },
                              expression: "item.price"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("price_percentage")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "price_percentage",
                            label: _vm._f("pgettext")("Price %", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "3",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip:
                              _vm.fieldsByName["price_percentage"].help,
                            appendText: "%"
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "price_percentage_enabled" },
                                  model: {
                                    value: _vm.item.$updates.price_percentage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "price_percentage",
                                        $$v
                                      )
                                    },
                                    expression: "item.$updates.price_percentage"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              mask: "number",
                              unmask: "typed",
                              scale: "4",
                              name: "price_percentage",
                              disabled: !_vm.item.$updates.price_percentage
                            },
                            model: {
                              value: _vm.item.price_percentage,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "price_percentage", $$v)
                              },
                              expression: "item.price_percentage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("discount_percentage")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "discount_percentage",
                            label: _vm._f("pgettext")("Discount %", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "3",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip:
                              _vm.fieldsByName["discount_percentage"].help,
                            appendText: "%"
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: {
                                    name: "discount_percentage_enabled"
                                  },
                                  model: {
                                    value:
                                      _vm.item.$updates.discount_percentage,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.item.$updates,
                                        "discount_percentage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "item.$updates.discount_percentage"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormInput", {
                            attrs: {
                              mask: "number",
                              unmask: "typed",
                              scale: "4",
                              name: "discount_percentage",
                              disabled: !_vm.item.$updates.discount_percentage
                            },
                            model: {
                              value: _vm.item.discount_percentage,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "discount_percentage", $$v)
                              },
                              expression: "item.discount_percentage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isFieldVisible("notes")
                    ? _c(
                        "ItpFormGroup",
                        {
                          staticClass: "col",
                          attrs: {
                            name: "notes",
                            label: _vm._f("pgettext")("Notes", "Invoice"),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            contentClass: "input-group",
                            helpTooltip: _vm.fieldsByName["notes"].help
                          }
                        },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c(
                              "div",
                              { staticClass: "input-group-text" },
                              [
                                _c("ItpFormCheckbox", {
                                  attrs: { name: "notes_enabled" },
                                  model: {
                                    value: _vm.item.$updates.notes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.item.$updates, "notes", $$v)
                                    },
                                    expression: "item.$updates.notes"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("ItpFormTextarea", {
                            attrs: {
                              name: "notes",
                              disabled: !_vm.item.$updates.notes
                            },
                            model: {
                              value: _vm.item.notes,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "notes", $$v)
                              },
                              expression: "item.notes"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  disabled:
                    !_vm.forms[_vm.formName] ||
                    !_vm.forms[_vm.formName].submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }